var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C4.00497 3.5838 7.58377 0.00494385 12 0C16.4162 0.00494385 19.995 3.5838 20 8C20 11.514 15 20.026 12.852 23.523C12.6715 23.8206 12.3481 24.0016 12 24C11.6526 24.0001 11.33 23.8199 11.148 23.524C9 20.025 4 11.51 4 8ZM8.5 8C8.5 9.93298 10.067 11.5 12 11.5C13.933 11.5 15.5 9.93298 15.5 8C15.5 6.06702 13.933 4.5 12 4.5C10.067 4.5 8.5 6.06702 8.5 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c3974721.svg";
export { ForwardRef as ReactComponent };